import { Language } from 'ha/i18n';
import preprocessResponse from 'ha/utils/preprocessResponse';
import FetchClient from 'ha/helpers/FetchClient';
import { ExtendedCanonicalCollectionTypes } from 'ha/pages/Country/types';

interface CitiesBody {
  code: string;
  lang: Language;
  minPopulation: number;
  minListings: number;
  index: string;
  categories: Array<{
    name: ExtendedCanonicalCollectionTypes;
    filters: string;
  }>;
}

interface City {
  cityCanonical: string;
  cityName: string;
  countryName: string;
  categories: ExtendedCanonicalCollectionTypes[] | null;
}

export interface CountryResponse {
  cities: City[];
}

export default function makeAlmanacService(
  fetchClient: FetchClient,
  defaultAlgoliaIndex: string,
) {
  return {
    loadCountry: (
      body: Omit<CitiesBody, 'index'>,
    ): Promise<CountryResponse> => {
      return fetchClient
        .fetch('/api/v1/countries/', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            ...body,
            index: defaultAlgoliaIndex,
          }),
        })
        .then(preprocessResponse);
    },
  };
}
